var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.qrcode)?_c('div',{staticClass:"com"},[_c('img',{staticClass:"wx-qrcode",attrs:{"src":_vm.qrcode,"alt":"","srcset":""}}),_c('div',[_vm._v("公众号: "+_vm._s(_vm.wechat_name))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }